// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Administrators compare job health with cost and processing
 * metrics during the same operational workflow. This route supplies the shared
 * background and one content container, while the jobs subsystem renders the
 * status cards and table; keeping that split prevents this dashboard from
 * drifting out of alignment with Costs and Metrics.
 */
import { JobsComponent } from '@/subsystems/jobs';
import { useAuth } from '@/subsystems/workspaces';
import { apiClient } from "@/app-shell/api/api-client";

export default function Jobs() {
  const { selectedOrganizationId, selectedWorkspaceId, isGlobalAdmin } = useAuth();

  return (
    <div className="min-h-full bg-slate-50">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <JobsComponent
          app_id="docreview"
          org_id={selectedOrganizationId || 'demo-org'}
          ws_id={selectedWorkspaceId || 'demo-workspace'}
          isGlobalAdmin={isGlobalAdmin}
          apiInstance={apiClient.getAxiosInstance()}
        />
      </div>
    </div>
  );
}
